// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"c21910e4","854":"804ad42c"}[chunkId] + ".chunk.js";
};